import { render, staticRenderFns } from "./ConfigBase.vue?vue&type=template&id=3afbd744"
import script from "./ConfigBase.vue?vue&type=script&lang=js"
export * from "./ConfigBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afbd744')) {
      api.createRecord('3afbd744', component.options)
    } else {
      api.reload('3afbd744', component.options)
    }
    module.hot.accept("./ConfigBase.vue?vue&type=template&id=3afbd744", function () {
      api.rerender('3afbd744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/pop_over/ConfigBase.vue"
export default component.exports